interface GoogleTagConfig {
    gtmId: string;
    gtagId?: string; // Google Ads (gtag.js) — solo centros que lo usan
}

export class GoogleTagHelper {
    // idCenter → configuración de Google Tag Manager (+ Google Ads opcional)
    private static readonly CENTER_CONFIGS = new Map<number, GoogleTagConfig>([
        // [TD-18681] Cadena UFC GYM: GTM + Google Ads
        // https://intelinova.atlassian.net/browse/TD-18681
        [11014, { gtmId: 'GTM-5BXG73D', gtagId: 'AW-742348662' }],
        [11010, { gtmId: 'GTM-5BXG73D', gtagId: 'AW-742348662' }],
        [11011, { gtmId: 'GTM-5BXG73D', gtagId: 'AW-742348662' }],
        [11012, { gtmId: 'GTM-5BXG73D', gtagId: 'AW-742348662' }],
        [11009, { gtmId: 'GTM-5BXG73D', gtagId: 'AW-742348662' }],
        [10882, { gtmId: 'GTM-5BXG73D', gtagId: 'AW-742348662' }],
        // [TD-18969] SUMMIT WELLNESS CLUB (Fitzy): solo GTM
        // https://intelinova.atlassian.net/browse/TD-18969
        [11680, { gtmId: 'GTM-MJ526TVS' }]
    ]);

    static isGoogleTagCenter(idCenter: number): boolean {
        return GoogleTagHelper.CENTER_CONFIGS.has(idCenter);
    }

    static getHeaderScripts(idCenter: number): string {
        const config = GoogleTagHelper.CENTER_CONFIGS.get(idCenter);
        if (!config) {
            return '';
        }

        // Consent Mode v2: estado por defecto denegado antes de cargar GTM; Cookiebot envia el 'consent update' al aceptar el banner.
        // data-cookieconsent="ignore" evita que el bloqueo automatico de Cookiebot impida cargar estos scripts (los tags internos quedan gobernados por Consent Mode).
        let scripts = `<!-- Google Consent Mode v2 -->
<script data-cookieconsent="ignore">
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('consent', 'default', {
    ad_storage: 'denied',
    analytics_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    wait_for_update: 500
});
gtag('set', 'ads_data_redaction', true);
</script>
<!-- Google Tag Manager -->
<script data-cookieconsent="ignore">(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${config.gtmId}');</script>
<!-- End Google Tag Manager -->`;

        if (config.gtagId) {
            scripts += `
<!-- Google tag (gtag.js) -->
<script async src="https://www.googletagmanager.com/gtag/js?id=${config.gtagId}" data-cookieconsent="ignore"></script>
<script data-cookieconsent="ignore">
gtag('js', new Date());
gtag('config', '${config.gtagId}');
</script>`;
        }

        return scripts;
    }

    static getNoScript(idCenter: number): string {
        const config = GoogleTagHelper.CENTER_CONFIGS.get(idCenter);
        if (!config) {
            return '';
        }

        return `<!-- Google Tag Manager (noscript) --><noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${config.gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript><!-- End Google Tag Manager (noscript) -->`;
    }
}
